module.exports = __webpack_public_path__ + "static/fonts/open-sans-regular.049a929.ttf";